import type { ReactNode } from 'react'

import { cn } from 'utils/classMerge'

type StepWrapperProps = {
  children: ReactNode
  className?: string | undefined
  small?: boolean
}

export const StepWrapper = ({
  children,
  className = '',
  small = false,
}: StepWrapperProps) => {
  return (
    <div
      className={cn(
        'tw-w-full tw-h-full tw-min-h-inherit tw-flex tw-flex-col tw-relative tw-mx-auto tw-flex-grow tw-justify-between mo:tw-justify-normal mo:tw-min-h-fit mo:tw-h-fit',
        { 'tw-h-[350px] tw-min-h-[350px]': small },
        className,
      )}
    >
      {children}
    </div>
  )
}
